import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { ResetPasswordConfigurationService } from '../configuration/auth/reset-password/reset-password-configuration.service';
import { HttpUrlBuilderService } from '../http/http-url-builder.service';
import { ClientConfigurationService } from '../configuration/auth/client/client-configuration.service';
import { AuthModule } from './auth.module';
import { AuthorityService } from './authority/authority.service';

@Injectable({
  providedIn: AuthModule
})
export class ResetPasswordService {
  get clientConfiguration() {
    return this.clientConfigurationService.configuration;
  }

  get resetPasswordConfiguration() {
    return this.resetPasswordConfigurationService.configuration;
  }

  get parameters() {
    return  {
      response_type: this.response_type,
      client_id: this.clientId,
      redirect_uri: this.redirect_uri
    };
  }

  get response_type() {
    return "code";
  }

  get redirect_uri() {
    return this.resetPasswordConfiguration.redirect_uri;
  }

  get clientId() {
    return this.clientConfiguration.clientId;
  }

  get path() {
    return this.resetPasswordConfiguration.path;
  }

  get parametersHttpOptions() {
    return {
      fromObject: this.parameters
    };
  }

  get httpParams() {
    return new HttpParams(this.parametersHttpOptions);
  }

  constructor(private resetPasswordConfigurationService: ResetPasswordConfigurationService,
    private httpUrlBuilder: HttpUrlBuilderService,
    private clientConfigurationService: ClientConfigurationService,
    private authorityService: AuthorityService) { }

  buildUrl(protocol, domain, port, path, httpParams) {
    return this.httpUrlBuilder.createParamUrl(protocol, domain, port, path, httpParams);
  }

  buildImplicitPortParamsUrl(protocol, domain, path, httpParams) {
    return this.httpUrlBuilder.createImplicitPortParamUrl(protocol, domain, path, httpParams);
  }

  resetPassword() {
    window.open(this.createResourceUrl(), "_blank");
  }

  createResourceUrl() {
    return this.authorityService.createResourceUrl(this.path);
  }
}
